
document.querySelectorAll('[data-sunset-carousel]').forEach((section) => {
  if (section.dataset.carouselInitialized === 'true') return;

  section.dataset.carouselInitialized = 'true';

  const track = section.querySelector('[data-carousel-track]');
  const prev = section.querySelector('[data-carousel-prev]');
  const next = section.querySelector('[data-carousel-next]');

  if (!track || !prev || !next) return;

  const updateArrows = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;

    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  };

  const scrollCarousel = (direction) => {
    const firstCard = track.querySelector('.sunset-product-card');
    if (!firstCard) return;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap) || 0;
    const distance = (firstCard.getBoundingClientRect().width + gap) * 3;

    track.scrollBy({
      left: direction * distance,
      behavior: 'smooth'
    });
  };

  prev.addEventListener('click', () => scrollCarousel(-1));
  next.addEventListener('click', () => scrollCarousel(1));

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);

  updateArrows();
});
